import { capturePageAction, Severity } from '@chegg/observability';
import isWindowDefined from '../isWindowDefined';
var CheggTldRegex = /(chegg[^\.]*)(.+)$/;
var CheggTlds = ['.com', '.com.mx'];

/**
 * Function to return TLD from hostname with ".com" being the fallback.
 * @param hostname
 * @returns TLD e.g. ".com", ".com.mx"
 */
export default function getTldFromHostname(hostname, source) {
  var _hostnameOrWindowHost;
  // cya fallback in case hostname is not provided somehow. if the fallback
  // hostname is still undefined, there is probably a problem during SSR
  var hostnameOrWindowHostname = '';
  var trimmedHostname = typeof hostname === 'string' && hostname.trim();
  if (trimmedHostname) {
    hostnameOrWindowHostname = trimmedHostname;
  } else if (isWindowDefined) {
    hostnameOrWindowHostname = window.location.hostname;
  }
  var tld = (_hostnameOrWindowHost = hostnameOrWindowHostname.match(CheggTldRegex)) === null || _hostnameOrWindowHost === void 0 ? void 0 : _hostnameOrWindowHost[2];
  var cheggHostname = trimmedHostname === '' ? 'hostname is an empty string' : trimmedHostname === false ? "hostname is ".concat(hostname) : 'hostname unknown';
  var cheggHref = isWindowDefined ? window.location.href : 'window is not defined';
  var cheggSource = source || 'source undefined';
  if (!tld) {
    capturePageAction({
      action: 'Unable to get tld from hostname',
      location: 'getGqlUrl.ts',
      severity: Severity.INFO
    }, {
      cheggHostname: cheggHostname,
      cheggHref: cheggHref,
      cheggSource: cheggSource,
      teamName: 'NEXUS'
    });
  }
  if (tld && !CheggTlds.includes(tld)) {
    capturePageAction({
      action: 'tld is not .com or .com.mx',
      location: 'getGqlUrl.ts',
      severity: Severity.INFO
    }, {
      cheggHostname: cheggHostname,
      cheggHref: cheggHref,
      cheggSource: cheggSource,
      teamName: 'NEXUS'
    });
  }

  // check tld in case a jank hostname is given
  if (!tld || !CheggTlds.includes(tld)) {
    // TODO: reenable after source of issue
    // captureError(
    //   {
    //     error: new Error('Invalid tld.'),
    //     location: 'getGqlUrl',
    //     severity: Severity.ERROR,
    //   },
    //   {
    //     teamName: 'NEXUS',
    //   },
    // );

    // set default tld
    tld = '.com';
  }
  return tld;
}